// @flow
import React, { Component } from 'react';
import { reduxForm, Field, destroy } from 'redux-form';
import {
  WizardForm,
  FormTitleH5,
  FormSubTitleSpan
} from '../../../../../components/WizardFormStyles';
import { DefaultIcon } from '../../../../../components/Icon';
import Input from '../../../../../components/Input';
import SubmitButton from '../../../../../components/SubmitButton';
import { handleSubmit } from '../handleSubmit';
import {
  requiredField,
  phoneNumber,
  emailValidation
} from '../../../../../utilities/validations';
import { showSuccessModal } from '../../../../../modules/ModalConductor/reducer';
import { history } from '../../../../../utilities/history';

type Props = {
  error?: string,
  handleSubmit: Function,
  submitting: boolean
};

class ContactDetails extends Component<Props> {
  render() {
    return (
      <WizardForm onSubmit={this.props.handleSubmit}>
        <FormTitleH5>
          <DefaultIcon name="phone" />
          <span>Administrative Contact</span>
        </FormTitleH5>
        <Field
          name="company_contact_attributes.administrative_name"
          label="Name"
          component={Input}
          validate={requiredField}
        />
        <Field
          name="company_contact_attributes.administrative_phone"
          label="Phone"
          type="tel"
          component={Input}
          validate={[requiredField, phoneNumber]}
        />
        <Field
          name="company_contact_attributes.administrative_email"
          label="Email"
          type="email"
          component={Input}
          validate={[requiredField, emailValidation]}
        />
        <FormTitleH5>
          <DefaultIcon name="techScreen" />
          <span>Technical Contact</span>
          <FormSubTitleSpan>Optional</FormSubTitleSpan>
        </FormTitleH5>
        <Field
          name="company_contact_attributes.technical_name"
          label="Name"
          component={Input}
        />
        <Field
          name="company_contact_attributes.technical_phone"
          label="Phone"
          type="tel"
          component={Input}
          validate={phoneNumber}
        />
        <Field
          name="company_contact_attributes.technical_email"
          label="Email"
          type="email"
          component={Input}
        />
        <SubmitButton
          error={this.props.error}
          value="Submit Application"
          disabled={this.props.submitting}
        />
      </WizardForm>
    );
  }
}

const onSubmitSuccess = (result, dispatch, props) => {
  dispatch(
    showSuccessModal(
      'Merchant Application Submitted Successfully',
      'Once the merchant application is approved, your merchant will receive an email to complete the sign up process.'
    )
  );
  dispatch(destroy('verification'));
  if (props.values.failed_merchant_application_id) {
    dispatch(
      props.deleteFailedMerchant(props.values.failed_merchant_application_id)
    );
  }
  history.push('/merchants/registrations/form/1');
};

export default reduxForm({
  form: 'verification',
  forceUnregisterOnUnmount: true,
  destroyOnUnmount: false,
  onSubmit: handleSubmit,
  onSubmitSuccess
  // $FlowFixMe
})(ContactDetails);
